import declare from	"dojo/_base/declare";
import NewFrom from "csi/table/NewFrom";
import xml from	"csi/xml";

const NewFromFoodSKURecipeDataSheetController = declare(NewFrom, {

	/**
     * @override
     * Add Node Operations to add New Recipe copies to FoodSKU and its parent Food
     */
	_toWriterParent() {
		this.inherited(arguments);

		const cache = this.m_cache;
		const foodSKU = cache.getNode(this.m_urlParent);
		const parentFood = cache.getNode(foodSKU.__Parent__);
		this.m_writer.changeParent(parentFood.$URL, "DataSheets", xml.ATTR_REFLIST, this.m_value, true);
	},

});

export = NewFromFoodSKURecipeDataSheetController;
